import { render, staticRenderFns } from "./search-table.vue?vue&type=template&id=2d367fb2&scoped=true&"
import script from "./search-table.vue?vue&type=script&lang=js&"
export * from "./search-table.vue?vue&type=script&lang=js&"
import style0 from "./search-table.vue?vue&type=style&index=0&id=2d367fb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d367fb2",
  null
  
)

export default component.exports